<template>
  <div class="horizontal-focus">
    <div v-for="bar in distribution" :key="bar.label" class="horizontal-focus__bar">
      <span class="horizontal-focus__bar-label">{{ bar.label }}</span>
      <div
        class="horizontal-focus__bar-line"
        :style="{
          backgroundColor: bar.color,
          width: Math.max(minBarWidth, (bar.value / highestValue) * 100) + '%',
        }"
      />
      <span class="horizontal-focus__bar-value" :style="{ color: bar.color }">
        {{ Math.round(bar.value * 100) }}
        <span class="horizontal-focus__bar-unit">{{ $t('ui.symbol.percentage') }}</span>
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HorizontalFocusDistribution',

  props: {
    distribution: {
      type: Array,
      default: null,
    },
    minBarWidth: {
      type: Number,
      default: 10,
    },
  },

  computed: {
    highestValue() {
      return this.distribution.reduce(
        (highestValue, { value }) => Math.max(highestValue, value),
        0
      );
    },
  },
};
</script>

<style lang="scss">
.horizontal-focus {
  position: relative;
  min-width: 120px;
}

.horizontal-focus__bar {
  display: grid;
  grid-template-columns: 1fr auto;
  grid-template-rows: auto auto;

  & + & {
    margin-top: 20px;
  }
}

.horizontal-focus__bar-label {
  margin-bottom: 10px;
  grid-column: 1 / span 2;
}

$bar-height: 15px;
.horizontal-focus__bar-line {
  height: $bar-height;
  border-radius: 5px;
  grid-column: 1;
  grid-row: 2;
}

.horizontal-focus__bar-value {
  line-height: $bar-height;
  text-align: right;
  font-weight: bold;
  grid-row: 2;
  margin-left: 10px;
}

.horizontal-focus__bar-unit {
  font-weight: normal;
}
</style>
